import $ from 'jquery';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';
import 'jquery-match-height';

import createBehavior from '../create-behavior';


export default () => {
    class PromoGroupTable {
        constructor($el, context, settings) {
            $el.clone(true).appendTo($el).addClass('promo-group__table-clone');
            // $el.find(".promo-group__table-wrap").mCustomScrollbar({
            //     axis: "x",
            //     scrollbarPosition: 'outside'
            // });

            let tableFirst = $el.find('> .promo-group__table-wrap');
            let tableSecond = $el.find('.promo-group__table-clone .promo-group__table-wrap');
            tableSecond.on('scroll', function () {
                let tablePos =  $(this).find('.promo-group__table-main').position().left;
                let tableFirstPos = Math.abs(tablePos);
                tableFirst.scrollLeft(tableFirstPos);
            });
            
            
            let innerline = $el.find('tbody tr');
            let headline = $el.find('thead tr');
            let headtableline = headline.find('tr');

            innerline.each(function () {
                let lnheight = $(this).outerHeight();
                let innertable = $(this).find('table');
                innertable.css('height', lnheight - 1);
            });
            function calcHeight() {
                let maxHeight = 0;
                $(headtableline).height('0');
                $(headtableline).each(function(){
                    let thisH = $(this).height();
                    if (thisH > maxHeight) { maxHeight = thisH; }
                });
                $(headtableline).height(maxHeight);
            }
            calcHeight();
            $(window).on('resize', calcHeight);
        }
    }

    createBehavior('.promo-group__table', 'PromoGroupTable', PromoGroupTable);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/promo-group-table.js